<template>
    <div class='LineChart'>
        <div class='header'>
            <h3>{{ title }}</h3>

        </div>
        <div class='content' ref='echars'>

        </div>
    </div>
</template>

<script>
    import { lineChartOptions,chartMapping } from '@/components/page/maintainPage/data';
    import { getTheFullMacroApi } from '@/utils/api';
    export default{
        props: {
          title:{
              type:String,
              default:()=>''
          },
            macroType:{
                type:Number,
                default:()=>0
            }
        },

        data(){
            return {
                code:'',
                options:this.$core.deepCopy(lineChartOptions),
                myChart:''
            }
        },
        mounted() {
            this.myChart = this.$echarts.init(this.$refs.echars)
            window.addEventListener('resize', this.charsResize);
            const chars = this.myChart
            getTheFullMacroApi(this.macroType).then(res=>{
                this.options.series.forEach(item=>{
                    item.data = []
                })
                this.options.yAxis = {
                    type: 'value'
                }
                this.options.xAxis.data = res.data.map(item=>item.date.slice(0,7))
                // options.legend.data =
                this.options.legend.data = chartMapping[this.macroType-1].title
                if(chartMapping[this.macroType-1].yAxis){
                    this.options.yAxis = chartMapping[this.macroType-1].yAxis
                }
                chartMapping[this.macroType-1].dateName.forEach((item,index)=>{
                    this.options.series.push({
                        name:chartMapping[this.macroType-1].title[index],
                        data:  res.data.map(s=>s[item]),
                        type: 'line',
                        lineStyle: {
                            width: 3, // 设置线条宽度为2像素
                        },
                    }, )
                })
                chars.setOption(this.options)
            })
        },
        destroyed() {
            window.removeEventListener('resize', this.charsResize)
        },
        methods:{
            //改变echars高度宽度
            charsResize(){
                if(this.myChart){
                    this.myChart.resize();
                }
            },
        }
    }
</script>

<style scoped lang='scss'>
.LineChart{
    display: flex;
    flex-direction: column;
    height: 100%;
    .header{
        height: 56px;
        padding: 0 32px;
        display: flex;
        align-items: center;
        h3{
            font-size: 18px;
            font-family: Microsoft YaHei,serif;
            font-weight: bold;
            color: #3C3C3C;
        }
        border-bottom: 2px solid #ebe8e8;
    }
    .content{
        flex: 1;
    }
}
</style>
